export const languages = {
  LV: "LV",
  EN: "EN",
};

export const locales = [
  {
    language: languages.LV,
    messages: {
      aboutUs: "PAR MUMS",
      services: "PAKALPOJUMI",
      cosmetics: "KOSMĒTIKA",
      promotions: "AKCIJAS",
      contacts: "KONTAKTI",
      aboutPage: {
        header: "Skaistumu nevar mākslīgi radīt - skaistums ir brīnišķīga iekšēja harmonija, vieglums, iedvesma un labsajūta.Tā ir viegla, iedvesmojoša sajūta, kad esi iemīlējusies sevī un izmanto mūsdienu tehnoloģijas darbā.",
        paragraph1: "Cienījamās dāmas un kungi! Draudzīgais „Lanta” salona kolektīvs aicina Jūs padomāt par sevi un ienirt siltas, sirsnīgas atmosfēras pasaulē.Mēs ar prieku palīdzam gan skaistās dāmas, gan vīriešiem vienmēr izskatīties nevainojami.Mūsu salons Daugavpilī darbojas jau kopš 1998. gada, nepārtraukti paplašinot pakalpojumu klāstu un izmantojot jaunākās tehnoloģijas.",
        paragraph2: "Mēs priecājamies par katru klientu! Mūsu pieredzējušie meistari regulāri pilnveido kvalifikāciju, apmeklējot dažādus kursus, lai piedāvātu tikai augstākās kvalitātes pakalpojumus.To palīdz īstenot gan bagātā iztēle, gan modernā aprīkojuma klāsts.",
        paragraph3: "Mūsu filozofija - sniegt klientam ne tikai pakalpojumus, bet arī draudzīgu attieksmi.",
        paragraph4: "Mūsu mērķis - padarīt Jūs laimīgus.",
        paragraph5: "Mūsu ceļš - sekot pasaules tendencēm un modes aktualitātēm.",
      },
      preview: {
        spotText: "Esi skaista",
        spotTextMall: "Skaistumkopšanas saloni Daugavpilī",
      },
      servicesPage: {
        pageName: "Mūsu pakalpojumi",
        hairdresserServices: "FRIZIERU PAKALPOJUMI",
        newHaircuts: "Matu griezums",
        newHairmake: "Matu veidošana",
        newHairproc: "Matu procedūras",
        newHairnight: "Vakara frizūra",
        coloring: "Matu krāsošana vienā tonī/ šķipsnās un/vai vairākos toņos",
        newcoloringremove: "Iepriekšējās matu krāsas noņemšana, matu tonēšana",
        newHairwawing: "Ilgviļņi",
        manHaircuts: "Matu griezums vīriešiem",
        childsHaircuts: "Matu griezums bērniem",
        manicurePedicure: "MANIKĪRA, PEDIKĪRA PAKALPOJUMI",
        manicure: "Klasiskais manikīrs",
        newgelishmanicure: "Gēllakas uzklāšana",
        newgelishremoce: "Gēllakas noņemšana",
        newmanicuredesign: "Nagu dizains",
        pedicure: "Klasiskais vai aparātpedikīrs",
        newfootnail: "Kāju nagu apkope",
        newfootnailgelish: "Gēllakas uzklāšana kāju nagiem",
        newnailgel: "Gēla nagu uzlikšana rokām",
        nailExtension: "Gēla nagu pieaudzēšana-nagu garuma",
        correction: "Izveidošana",
        newnailacril: "Akrila nagu uzlikšana rokām",
        newgelgelishremove: "Gēla vai akrila noņemšana",
        bodyAndFaceCare: "Ķermeņa un sejas kopšana",
        newvask: "Vaksācija sievietēm un vīriešiem",
        newears: "Ausu caurduršana",
        piercing: "Pīrsings",
        eyebrowCorrection: "Uzacu korekcija/krāsošana",
        eyelashes: "Skropstu krāsošana",
        eyelashPerm: "Skropstu/uzacu laminēšana",
        makeup: "Meikaps",
        cleansesAndFaceMasks: "Sejas ādas tīrīšana/ procedūras/maskas",
        solarium: "SOLĀRIJS",
        horizontal: "Horizontālais solārijs (Ergoline Turbo 450)",
        vertical: "Vertikālais solārijs (Luxura)",
        sunCream: "Saules iedeguma krēmi",
      },
      contactsPage: {
        contacts: "Mūsu kontakti",
        mon_fri: "P.-P. {time}",
        sat: "S. {time}",
        sun: "Sv. {time}",
        mon: "P. {time}",
        tue_fri: "O.-P. {time}",
        address: "Adrese",
        tell: "Tālrunis",
        workTime: "Darba laiks",
        email: "E-pasts",
      },
      cosmeticsPage: {
        pageName: "Mūsu kosmētika",
      },
      discountPage: {
        happyDays: "LAIMĪGĀ DIENA",
        sunday: "Svētdiena",
        discountCosmetics: "{percent} atlaide kosmētikai",
        discountSolarium: "{percent} atlaide solārijam",
        happyHours: "LAIMĪGĀS STUNDAS",
        discountTime: "No 8.00 līdz 10.00",
        subscription: "ABONEMENTS",
      },
    },
  },
  {
    language: languages.RU,
    messages: {
      aboutUs: "О НАС",
      services: "УСЛУГИ",
      cosmetics: "КОСМЕТИКА",
      promotions: "АКЦИИ",
      contacts: "КОНТАКТЫ",
      aboutPage: {
        header:
          "Красоту нельзя создать искусственно - это внутренняя гармония, лёгкость, вдохновение и ощущение комфорта. Это то самое состояние, когда ты влюбляешься в себя и используешь в работе современные технологии.",
        paragraph1:
          "Дорогие дамы и господа! Дружная команда салона «Lanta» приглашает вас уделить время себе и окунуться в тёплую, душевную атмосферу. Мы с удовольствием помогаем и женщинам, и мужчинам всегда выглядеть безупречно. Наш салон в Даугавпилсе работает с 1998 года, постоянно расширяя спектр услуг и применяя современные технологии.",
        paragraph2:
          "Мы ценим каждого клиента! Наши опытные мастера регулярно повышают квалификацию, посещая различные курсы, чтобы предлагать услуги только высокого уровня. Этому помогают творческий подход и современное оборудование.",
        paragraph3:
          "Наша философия - не только качественные услуги, но и искреннее, дружелюбное отношение.",
        paragraph4: "Наша цель - сделать вас счастливыми.",
        paragraph5:
          "Наш путь - следовать мировым тенденциям и актуальным направлениям моды."
      },
      preview: {
        spotText: "Будь красивой",
        spotTextMall: "Салоны красоты в Даугавпилсе"
      },
      servicesPage: {
        pageName: "Наши услуги",
        hairdresserServices: "ПАРИКМАХЕРСКИЕ УСЛУГИ",
        newHaircuts: "Стрижка",
        newHairmake: "Укладка",
        newHairproc: "Процедуры для волос",
        newHairnight: "Вечерняя причёска",
        coloring: "Окрашивание в один тон / мелирование и/или окрашивание в несколько тонов",
        newcoloringremove: "Снятие предыдущего окрашивания, тонирование",
        newHairwawing: "Химическая завивка",
        manHaircuts: "Мужская стрижка",
        childsHaircuts: "Детская стрижка",
        manicurePedicure: "МАНИКЮР И ПЕДИКЮР",
        manicure: "Классический маникюр",
        newgelishmanicure: "Покрытие гель-лаком",
        newgelishremoce: "Снятие гель-лака",
        newmanicuredesign: "Дизайн ногтей",
        pedicure: "Классический или аппаратный педикюр",
        newfootnail: "Уход за ногтями на ногах",
        newfootnailgelish: "Покрытие гель-лаком на ногах",
        newnailgel: "Гелевые ногти (руки)",
        nailExtension: "Наращивание гелем (длина)",
        correction: "Моделирование",
        newnailacril: "Акриловые ногти (руки)",
        newgelgelishremove: "Снятие геля или акрила",
        bodyAndFaceCare: "Уход за телом и лицом",
        newvask: "Ваксинг для женщин и мужчин",
        newears: "Прокол ушей",
        piercing: "Пирсинг",
        eyebrowCorrection: "Коррекция / окрашивание бровей",
        eyelashes: "Окрашивание ресниц",
        eyelashPerm: "Ламинирование ресниц/бровей",
        makeup: "Макияж",
        cleansesAndFaceMasks: "Чистка лица / процедуры / маски",
        solarium: "СОЛЯРИЙ",
        horizontal: "Горизонтальный солярий (Ergoline Turbo 450)",
        vertical: "Вертикальный солярий (Luxura)",
        sunCream: "Кремы для загара"
      },
      contactsPage: {
        contacts: "Наши контакты",
        mon_fri: "Пн-Пт {time}",
        sat: "Сб {time}",
        sun: "Вс {time}",
        mon: "Пн {time}",
        tue_fri: "Вт-Пт {time}",
        address: "Адрес",
        tell: "Телефон",
        workTime: "Время работы",
        email: "E-mail"
      },
      cosmeticsPage: {
        pageName: "Наша косметика"
      },
      discountPage: {
        happyDays: "СЧАСТЛИВЫЙ ДЕНЬ",
        sunday: "Воскресенье",
        discountCosmetics: "{percent} скидка на косметику",
        discountSolarium: "{percent} скидка на солярий",
        happyHours: "СЧАСТЛИВЫЕ ЧАСЫ",
        discountTime: "С 8:00 до 10:00",
        subscription: "АБОНЕМЕНТ"
      }
    }
  },
  {
    language: languages.EN,
    messages: {
      aboutUs: "ABOUT US",
      services: "SERVICES",
      cosmetics: "COSMETICS",
      promotions: "OFFERS",
      contacts: "CONTACTS",
      aboutPage: {
        header:
          "Beauty can’t be manufactured — it’s a wonderful inner harmony: lightness, inspiration, and well-being. It’s that effortless, uplifting feeling when you fall in love with yourself and use modern technologies in your work.",
        paragraph1:
          "Dear Ladies and Gentlemen! The friendly team at “Lanta” salon invites you to take time for yourself and step into a world of warmth and sincere care. We’re happy to help both women and men look impeccable at all times. Our salon in Daugavpils has been operating since 1998, continuously expanding our range of services and using the latest technologies.",
        paragraph2:
          "We value every client! Our experienced specialists regularly improve their skills by attending different training courses, so we can offer only top-quality services. This is supported by both creative vision and a wide range of modern equipment.",
        paragraph3:
          "Our philosophy is to offer not only services, but also a friendly attitude.",
        paragraph4: "Our goal is to make you happy.",
        paragraph5:
          "Our path is to follow global trends and the latest in fashion."
      },
      preview: {
        spotText: "Be Beautiful",
        spotTextMall: "Beauty salons in Daugavpils"
      },
      servicesPage: {
        pageName: "Our Services",
        hairdresserServices: "HAIRDRESSING",
        newHaircuts: "Haircut",
        newHairmake: "Hair styling",
        newHairproc: "Hair treatments",
        newHairnight: "Evening hairstyle",
        coloring: "Single-process colour / highlights and/or multi-tone colouring",
        newcoloringremove: "Colour removal, toning",
        newHairwawing: "Perm",
        manHaircuts: "Men’s haircut",
        childsHaircuts: "Children’s haircut",
        manicurePedicure: "MANICURE & PEDICURE",
        manicure: "Classic manicure",
        newgelishmanicure: "Gel polish application",
        newgelishremoce: "Gel polish removal",
        newmanicuredesign: "Nail art",
        pedicure: "Classic or machine pedicure",
        newfootnail: "Toenail care",
        newfootnailgelish: "Gel polish for toenails",
        newnailgel: "Gel nails (hands)",
        nailExtension: "Gel nail extensions (length)",
        correction: "Sculpting",
        newnailacril: "Acrylic nails (hands)",
        newgelgelishremove: "Gel or acrylic removal",
        bodyAndFaceCare: "BODY & FACIAL CARE",
        newvask: "Waxing for women and men",
        newears: "Ear piercing",
        piercing: "Piercing",
        eyebrowCorrection: "Brow shaping / tinting",
        eyelashes: "Lash tinting",
        eyelashPerm: "Lash/brow lamination",
        makeup: "Makeup",
        cleansesAndFaceMasks: "Facial cleansing / treatments / masks",
        solarium: "TANNING",
        horizontal: "Horizontal sunbed (Ergoline Turbo 450)",
        vertical: "Vertical sunbed (Luxura)",
        sunCream: "Tanning creams"
      },
      contactsPage: {
        contacts: "Contact details",
        mon_fri: "Mon-Fri {time}",
        sat: "Sat {time}",
        sun: "Sun {time}",
        mon: "Mon {time}",
        tue_fri: "Tue-Fri {time}",
        address: "Address",
        tell: "Phone",
        workTime: "Opening hours",
        email: "Email"
      },
      cosmeticsPage: {
        pageName: "Our Cosmetics"
      },
      discountPage: {
        happyDays: "HAPPY DAY",
        sunday: "Sunday",
        discountCosmetics: "{percent} off cosmetics",
        discountSolarium: "{percent} off sunbed sessions",
        happyHours: "HAPPY HOURS",
        discountTime: "From 8:00 to 10:00",
        subscription: "MEMBERSHIP"
      }
    }
  }

];



export const discountPercents = {
  twenty: "-20%",
  fifteen: "-15%",
};
